const PROD_KEY = "pk_live_51JRkhTHe3spLiSeqh2EcoFYUtgP53bBF0f4iNQ71wvr10jWihAj0FOlyQEtluhP8Ep7p6K9tsNnnadHxXHDEXr8R00U8EHhDey";
const TEST_KEY =
  "pk_test_51JRkhTHe3spLiSeqe0h5z8eLBCBU4aSgp46RBqb3iBCgIjLB9Dd0grQWzg38cx8pzxpr32La05nsTxVxjI9defeQ00UdFchwBF";
export const STRIPE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === "production" ? PROD_KEY : TEST_KEY;
